import apiBaseUrl from '../../utils/config.js';

class ImageService {
    constructor() {
        this.baseUrl = `${apiBaseUrl}/images`;
    }

    getToken() {
        return localStorage.getItem("jwt");
    }

    getAuthHeaders() {
        const token = this.getToken();
        return {
            ...(token && { Authorization: `Bearer ${token}` }),
        };
    }

    async uploadImage(file, filename, directory) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('filename', filename);
  formData.append('directory', directory);

  const token = this.getToken(); // or localStorage.getItem("jwt")

  const response = await fetch(`${this.baseUrl}/upload`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` })
      // ⛔ DO NOT add 'Content-Type': browser will set correct boundary
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }

  return await response.text(); // URL or path
}


    getImageUrl(directory, filename) {
        if (!filename || filename.trim() === "") {
            return "/images/default.png";
        }

        const cleanFilename = filename.split('/').pop();
        const cleanDirectory = directory
            .replace(/^\/+/, '')                  // remove leading slashes
            .replace(/\/+$/, '')                  // remove trailing slashes
            .replace(/^api\/images\/+/, '');      // remove accidental full prefix

        return `${this.baseUrl}/${cleanDirectory}/${cleanFilename}`;
    }

    async getImage(directory, filename) {
        const url = this.getImageUrl(directory, filename);
        const response = await fetch(url, {
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error("Failed to fetch image");
        }

        return await response.blob();
    }

    async deleteImage(directory, filename) {
        const cleanDirectory = directory
            .replace(/^\/+/, '')
            .replace(/\/+$/, '')
            .replace(/^api\/images\/+/, '');

        const cleanFilename = filename.split('/').pop();

        const url = `${this.baseUrl}/newdir/${encodeURIComponent(cleanDirectory)}/${encodeURIComponent(cleanFilename)}`;

        const response = await fetch(url, {
            method: "DELETE",
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error("Failed to delete image");
        }

        return await response.text();
    }
}

// ✅ Named export of the class
export { ImageService };

// ✅ Default singleton instance
export default new ImageService();
